import { Component, OnInit, ViewChild, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { GetRenewalDetailService } from '../../adapters/getRenewalDetail.service';
import { environment } from '../../../environments/environment';
import { SharedDataService } from '../../shared/shared-data.service';
import { default as theme } from '../renewal-theme.json';
import { BaseComponents } from '../../base.component';
import { Injectable, Injector } from '@angular/core';
import { CommonService } from 'src/app/claim/services/common.service';
import * as uuid from 'uuid'
import { GetLineTokenService } from 'src/app/adapters/getLineToken.service';
import liff from '@line/liff';
import { CommonModule } from '@angular/common';

declare var window: any;

@Component({
  selector: 'app-motor-detail',
  templateUrl: './motor-detail.component.html',
  styleUrls: ['./motor-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class MotorDetailComponent extends BaseComponents implements OnInit {
  insuredetail_data = signal<any>(null);
  dataucid: any;
  letterucid: any;
  liff_id: string;
  rm_channelId: any;
  product_type: any;
  comcode: string;
  electronic_channel: any;
  old_insure_model: any;

  line_id: any;

  url_default: any;

  offerlogo: any;

  expiredate = signal<any>(null); 
  days: any = [];

  day: any;
  month: any;
  year: any;
  months: any = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

  loader = signal(false);
  style: any = {};
  ucid: string = uuid.v4();
  log_text :string = `motor detail ${this.ucid} `;
  show_additional_products = signal<boolean>(false);
  // access_token_line : string = "";
  liff_channel_id : string = "";
  channel_line_id : string = "";
  subChannel:number| null = null;
  constructor(
    protected injectorObj:Injector,
    private getRenewalDetailService: GetRenewalDetailService,
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService,    
    private getLineTokenService: GetLineTokenService) {
    super(injectorObj);
    this.insuredetail_data.set({
      additionalProduct: [],
      specialProduct: [],
      address: "",
      carBrand: "",
      carNo: "",
      carProvince: null,
      carUsage: null,
      carYear: null,
      claim: [],
      decoration: [],
      installment: [],
      insuredName: "",
      lastClaimDate: "",
      name: "",
      oldExpireDate: "",
      oldInsureModel: "",
      oldInsureNo: "",
      oldInsureType: null,
      oldInsureName: "",
      offerInsureClaim: "",
      offerInsureAmount: 0,
      offerInsureFund: 0,
      offerInsureType: null,
      phoneNo: "",
      protection1: 0,
      protection2: 0,
      protection3: 0,
      protection4: 0,
      protection5: 0,
      protection6: 0,
      protection7: 0,
      protection8: 0,
      protection9: 0,
      protection10: 0,
      protection11: 0,
      protection12: 0,
      refNo: "",
      totalamount: 0,
      insuranceType: "",
      product_type: "",
      instTerm: 0,
      instFirstDate: "",
      compareLength: 0,
    });
  }

  async ngOnInit() {
    const logFunction = `${this.log_text} ngOnInit => `
    this.logger.info(logFunction,"page motor-detail");
    await this.route.queryParams.subscribe(async params => {
      this.dataucid = params['dataucid'];
      this.letterucid = params['letterucid'];
      this.rm_channelId = params['rm_channelId'];
      this.liff_id = params['appRef'];
      this.product_type = params['product_type'];
      this.electronic_channel = params['electronic_channel']
      this.comcode = params['comcode'];
      this.style = theme[this.comcode];
      this.liff_channel_id = params['liff_channel_id'];
      this.channel_line_id = params['channel_line_id'];
      this.subChannel = params['subchannel'] ? parseInt(params['subchannel']) : null
      this.logger.info(logFunction,'params motor :', params)         
    });
    
    const request = { description: "LINE_RENEW_CONFIG" };
    this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG start");
    try {
      // this.access_token_line = await this.getLineTokenService.exec(liff,this.liff_id,this.logger);
      // this.logger.info(logFunction,"access_token_line",this.access_token_line);
      // if(environment.production){
      //   await liff.init({ liffId: this.liff_id});
      //   if(liff.isLoggedIn() === false && liff.isInClient() === false){
      //     this.logger.info(['login liff callback path:', window.location.href]);
      //     liff.login({ redirectUri: window.location.href })
      //   }else{
      //     this.access_token_line = await liff.getAccessToken();
      //     this.logger.debug(['access_token_line:', this.access_token_line]);
      //   }
      // }
      this.commonService.apiGetCommonConfig(request).subscribe(
        (response) => {
          if(response && response.data){
            this.logger.info(logFunction,"get common config LINE_RENEW_CONFIG success:",response.data.value);
            try{
              const dataJSON = JSON.parse(response.data.value);
              const configData = dataJSON.TOPUP_DISPLAY[this.electronic_channel];
              if(configData == "Y"){
                this.show_additional_products.set(true);
              }else{
                this.show_additional_products.set(false);
              }
            }catch(err){
              this.logger.error(logFunction,"get common config LINE_RENEW_CONFIG fail:",err.message);
              this.show_additional_products.set(false);
            }
          }
          
        },
        (error) => {
          this.logger.error(logFunction,"get common config LINE_RENEW_CONFIG fail:",error.message);
          this.show_additional_products.set(false);
        }
      )
      this.sharedDataService.getMotorDetail.subscribe(res => {
        this.logger.debug(logFunction,'sharedDataService :', res)
        if(res.length == 0) {
          this.logger.debug(logFunction,'sharedDataService res.length == 0 getData start')
          this.logger.info(logFunction,'get Data dataucid:',this.dataucid)
          this.logger.info(logFunction,'get Data letterucid:',this.letterucid);
          this.getData(this.dataucid, this.letterucid);
        } else {
          this.insuredetail_data.set(res);
          this.loader.set(true);
          this.afterGetData()
        }
      })
    }
    catch(error) {
      this.logger.error(logFunction,"error",error.message);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.log_text,'error motor-detail :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.log_text} error motor-detail:  ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
      // this.line_id = 'U74ab5721973babd747ef46b95d477fea';
    }  

    // try {
    //   await liff.init({ liffId: this.liff_id })
    //   this.logger.debug('liff_id : ' + this.liff_id);
    //   this.logger.debug('liff ' + liff);
    //   if (liff.isLoggedIn() == false && liff.isInClient()) {
    //     this.logger.debug('callback path : '+ window.location.href);
    //     liff.login({ redirectUri: window.location.href });
    //   }
    //   else {
    //     this.logger.debug('getdata');
    //     this.getData(this.dataucid, this.letterucid);
    //   }
    //   const profile = await liff.getProfile();
    //   this.logger.debug('getprofile : '+ profile);
    //   this.line_id = profile.userId;
    // }
    // catch (e) {
    //   this.line_id = ''
    //   this.logger.debug('Error ' + e);
    // };

    if (environment.log_level == 'debug') {
      window.vConsole = new window.VConsole();
    }
  }

  getData(dataucid: any, letterucid: any) {
    this.getRenewalDetailService.exec({ dataucid: dataucid, letterucid: letterucid }).then((res: any) => {
      this.insuredetail_data.set(res.data.obj);
      this.loader.set(true);
      this.afterGetData()
    }).catch((error) => {
      this.logger.error(`${this.log_text} error getRenewalDetailService  ${error?.message}`);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
      this.logger.error([this.log_text,'error getRenewalDetailService :', error?.message]);
      liff.logout()
      liff.login({ redirectUri: window.location.href })
      } else {
        this.logger.error(`${this.log_text} error motor-detail getRenewalDetailService  ${error?.message}`);
        this.router.navigate(['/renewal/page-error']);
      }
    });
  }

  afterGetData() {
    const data = this.insuredetail_data();
    this.old_insure_model = data?.oldInsureModel != null ? data?.oldInsureModel != 0 ? `ผู้ขับขี่ ${data?.oldInsureModel} คน` : 'ไม่ระบุ' : '';

    this.offerlogo = "/images/" + data?.logoOfferInsureBrand;
    document.getElementById('offerlogo').setAttribute('src', this.offerlogo);
    document.getElementById('offerlogo1').setAttribute('src', this.offerlogo);

    this.expiredate.set(new Date(data?.oldExpireDate));
    let month_expiredate = this.expiredate().getMonth();
    let day_expiredate = this.expiredate().getDate();
    let year_expiredate = this.expiredate().getFullYear();
    this.day = day_expiredate;
    this.month = this.months[parseInt(month_expiredate)];
    this.year = parseInt(year_expiredate) + 543;
    this.expiredate.set(this.day + ' ' + this.month.toString() + ' ' + this.year.toString());
    this.logger.debug(data);
  }

  numberWithCommas(x) {
    if (x == 0) {
      return '-'
    } else {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  getAdditionalLogo(x, y) {
    if (y != 'no logo') {
      let additionallogo = "/images/" + y;
      document.getElementById('additionallogo').setAttribute('src', additionallogo);
    }
    return x;
  }

  onSubmit() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "dataucid": this.dataucid,
        "letterucid": this.letterucid,
        "rm_channelId": this.rm_channelId,
        "appRef": this.liff_id,
        "product_type": this.product_type,
        "electronic_channel": this.electronic_channel,
        "comcode": this.comcode,
        "liff_channel_id": this.liff_channel_id,
        "channel_line_id": this.channel_line_id,
        "subchannel": this.subChannel
        
      }
    };
    this.router.navigate(['/renewal/motor-step'], navigationExtras);
  }

  onCompare() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "dataucid": this.dataucid,
        "letterucid": this.letterucid,
        "rm_channelId": this.rm_channelId,
        "appRef": this.liff_id,
        "product_type": this.product_type,
        "electronic_channel": this.electronic_channel,
        "comcode": this.comcode,
        "liff_channel_id": this.liff_channel_id,
        "channel_line_id": this.channel_line_id,
        "subchannel": this.subChannel
      }
    };
    this.router.navigate(['/renewal/insurance-compare'], navigationExtras);
  }

}
